export const getCurrentWeek = (calendar) => {
    if (!calendar || calendar.length === 0) {
      return 1;
    }

    const today = new Date();

    // Sort calendar by start_date to ensure proper order
    const sortedCalendar = [...calendar].sort((a, b) => new Date(a.start_date) - new Date(b.start_date));

    // Find the first week (preseason check)
    const firstWeek = sortedCalendar[0];
    const firstWeekStart = new Date(firstWeek.start_date);

    // Find the last week (postseason check)
    const lastWeek = sortedCalendar[sortedCalendar.length - 1];
    const lastWeekEnd = new Date(lastWeek.end_date);

    // Check if we're in preseason (before the first week starts)
    if (today < firstWeekStart) {
      return 1;
    }

    // Check if we're in postseason (after the last week ends)
    if (today > lastWeekEnd) {
      return lastWeek.week;
    }

    // Normal in-season logic - find the current week
    const currentWeek = sortedCalendar.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      return today >= startDate && today <= endDate;
    });

    if (currentWeek) {
      return currentWeek.week;
    }

    // Fallback: if we're between weeks, find the next upcoming week
    const nextWeek = sortedCalendar.find(week => {
      const startDate = new Date(week.start_date);
      return today < startDate;
    });

    if (nextWeek) {
      return nextWeek.week;
    }

    // Ultimate fallback
    return 1;
  };

export const formatGameDate = (dateString) => {
  try {
    // Parse ISO date string (YYYY-MM-DD)
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      console.error('Invalid date string:', dateString);
      return 'Invalid Date';
    }

    // Format to "Day, Month DD" (e.g., "Thu, Sep 14")
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error, 'for date string:', dateString);
    return 'Invalid Date';
  }
};
